<section class="secondary-drawer-container">
  <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
  <h5 class="drawer-title">Asset Recommendation</h5>
</section>
 
<div *ngIf="isAssetListLoading">
  <app-list-loader></app-list-loader>
</div>
 
<div class="custom-scroller email-notifications">
  <ng-container *ngIf="!isAssetListLoading">
    <mat-card class="d-inline-block w-100 float-start notifications">
      <!-- Asset Recommendation Details -->
      <div class="w-100 d-inline-block float-start">
        <!-- Recommendation Message -->
        <div>
          <mat-card class="mb-4 mat-elevation-z0 light-orange-card">
            This {{assetDetails.name}} is due for its scheduled maintenance {{getAssetMaintainanceType(assetDetails.maintenanceCycle)}}. 
            It is recommended to service the unit to ensure optimal performance and prevent future issues. 
          </mat-card>
        </div>
 
        <!-- Property Address and Attachments -->
        <div class="row">
          <div class="col-6 my-2 d-flex flex-column justify-content-between">
            <div class="col-12 brief-section">
              <div class="details float-start">
                <h5>Property Address</h5>
                <p>{{assetDetails.address}}</p>
              </div>
            </div>
            <div class="col-12 brief-section">
              <div class="details float-start">
                <h5>Asset Name</h5>
                <p>{{assetDetails.name}}</p>
              </div>
            </div>          
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Attachments</h5>
             <app-file-list-viewer
                  [files]="assetDetails?.attachments"
                  [isReadOnly]="true"
                ></app-file-list-viewer>
            </div>
          </div>        
        </div>
        <div class="row">
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Model</h5>
              <p>{{assetDetails.model}}</p>
            </div>
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Manufacturer</h5>
              <p>{{assetDetails.manufacture}}</p>
            </div>
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Date of Purchase</h5>
              <div class="date-time"><small>{{assetDetails.dateofpurchase | date:'dd MMM yyyy'}} at {{assetDetails.dateofpurchase |  date:'shortTime'}}</small></div>
            </div>
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Barcode</h5>
              <p>{{assetDetails.barcode}}</p>
            </div>
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Maintenance cycle</h5>
              <p>{{ maintenanceCycleLabel(assetDetails?.maintenanceCycle) }}</p>
            </div>
          </div>
          <div class="col-6 my-2 brief-section">
            <div class="details float-start">
              <h5>Useful Life Period (years)</h5>
              <p>{{assetDetails.usefullifeperiod}}</p>
            </div>
          </div>
          <div class="col-12 my-2 brief-section">
            <div class="details float-start">
              <h5>Description</h5>
              <p>{{assetDetails.description}}</p> <!-- Empty placeholder for description -->
            </div>
          </div>
          <div class="col-12 my-2 brief-section">
            <div class="details float-start">
              <h5>Note</h5>
              <p>{{assetDetails.note}}</p> <!-- Empty placeholder for note -->
            </div>          
          </div>
        </div>
 
       
      </div>
    </mat-card>
    <!-- Action Buttons -->
    <div class="inner-drawer-actions">
      <button class="card-button success mat-elevation-z0 me-2 mb-2" mat-button mat-raised-button (click)="acceptRecommendation()">Accept</button>
      <button class="card-button danger mat-elevation-z0 me-2 mb-2" mat-button mat-raised-button (click)="rejectRecommendation()" >Reject</button>
      <button class="card-button black mat-elevation-z0 me-2 mb-2" mat-button mat-raised-button (click)="snoozeRecommendation()" >Snooze</button>
    </div>
  </ng-container>
</div>